import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { GhostCalendar } from '../../containers/templates/GhostCalendar';

export const AdminCampaignsGhostCalendarPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<GhostCalendar />
		</AdminDashboardPageLayout>
	);
};
